import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props: any) => props.theme.colors.ce9ecef};
  padding: 16px 24px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  gap: 24px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const DiaSemana = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const DiaAbreviado = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.c6c757d};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const DiaNumero = styled.div`
  font-size: 32px;
  font-weight: 800;
  color: ${(props: any) => props.theme.colors.c212529};
  line-height: 1;
`;

export const DataCompleta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const DataTexto = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c495057};
  text-transform: capitalize;
`;

export const QuantidadeDemandas = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.c6c757d};
`;
